import React from "react";
import styled from "styled-components";

export default styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    color: white;
    font-size: 80px;
    text-shadow: 5px 5px 25px black;
    font-weight: 700;
    z-index: 20;
    display: none;
    
    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;